module.exports = class ContextHelper {
    static getPageCommonContext(props) {
        //console.log({props});
        const { page_data } = props.pageContext
        const common_content = page_data.find(element => {
            return (element.title === 'common')
        }).content;
        return {
            top_title: (page_data.find(element => {
                return (element.title === 'top_title')
            }) || {}).content,
            top_subtitle: (page_data.find(element => {
                return (element.title === 'top_subtitle')
            }) || {}).content,
            tech_stack: common_content.tech_stack,
            tech_stack_title: common_content.tech_stack_title,
            section_custom_software_title: common_content.section_custom_software_title,
            section_custom_software_content: common_content.section_custom_software_content,
            api_host: common_content.api_host,
            samples: common_content.samples || [],
            samples_title_1: common_content.samples_title_1,
            samples_title_2: common_content.samples_title_2
        }
    }

    static getPageSpecificContext(props){
        const { page_data } = props.pageContext
        let data = {};
        page_data.filter((element)=>{
            return (element.title !== 'common')
        }).forEach(element => {
            data[element.title] = element.content;
        });

        return data;
    }
}